export const submissionAuthorFields = [
  {
    id: "author_type",
    type: "select",
    label: "저자 유형",
    size: 50,
  },
  {
    id: "name_kor",
    type: "text",
    label: "이름",
    size: 50,
  },
  {
    id: "name_eng",
    type: "text",
    label: "이름(영문)",
    size: 50,
  },
  {
    id: "department",
    type: "text",
    label: "소속",
    size: 50,
  },
  {
    id: "email",
    type: "text",
    label: "이메일",
    size: 50,
  },
  {
    id: "positions",
    type: "text",
    label: "직위",
    size: 50,
  },
];

export const submissionPaperDetailFields = [
  {
    key: "submitted_at",
    label: "투고일",
    type: "text",
  },
  {
    key: "conference",
    label: "학술대회",
    type: "text",

  },
  {
    key: "title_ko",
    label: "제목",
    type: "text",
  },
  {
    key: "title_en",
    label: "제목(영문)",
    type: "text",
  },
  {
    key: "keyword_kor",
    label: "키워드",
    type: "text",
  },
  {
    key: "keyword_eng",
    label: "키워드(영문)",
    type: "text",
  },
  {
    key: "abstract_kor",
    label: "초록",
    type: "html",
  },
  {
    key: "abstract_eng",
    label: "초록(영문)",
    type: "html",
  },
  {
    key: "file_path",
    label: "논문 유사도 검사",
    type: "file",
  },
];

// TODO : API 대체
export const submissionAgreementFields = [
  {
    idx: 1,
    title: "연구윤리서약서",
    content:
      "본 서약자는 국제한국어응용언어학회(ISKAL)의 윤리 규정을 준수할 것을 서약합니다.",
  },
  {
    idx: 2,
    title: "연구윤리서약서2",
    content:
      "본 서약자는 국제한국어응용언어학회(ISKAL)의 윤리 규정을 준수할 것을 서약합니다.",
  },
  {
    idx: 3,
    title: "연구윤리서약서3",
    content:
      "본 서약자는 국제한국어응용언어학회(ISKAL)의 윤리 규정을 준수할 것을 서약합니다.",
  },
];

export const authorTypeOptions = [
  {
    idx: 1,
    label: "투고자",
    key: "SUBMITTER",
  },
  {
    idx: 2,
    label: "제 1 저자",
    key: "FIRST_AUTHOR",
  },
  {
    idx: 3,
    label: "교신저자",
    key: "CORRESPONDING_AUTHOR",
  },
  {
    idx: 4,
    label: "공저자",
    key: "CO_AUTHOR",
  },

]


export const reviewStandardOptions = [
  {
    idx: 1,
    label: "게재(80점 이상)",
    min_score: 80,
    max_score: 100,
  },
  {
    idx: 2,
    label: "수정 후 게재(70~79점)",
    min_score: 70,
    max_score: 79,
  },
  {
    idx: 3,
    label: "수정 후 재심(60~69점)",
    min_score: 60,
    max_score: 69,
  },
  {
    idx: 4,
    label: "게재 불가(60점 미만)",
    min_score: 0,
    max_score: 59,
  },
];